import React, { useState, useEffect } from "react";
import {useNavigate } from "react-router-dom";
import axios from "axios";
import "./BookingForm.scss";
import {toast} from 'react-toastify';
import PhoneInput from "./PhoneInput";

import 'react-toastify/dist/ReactToastify.css';

function BookingForm() {
  const [theme, setTheme] = useState(() => localStorage.getItem('bookingTheme') || 'dark');
  const [isPopupOpen, setIsPopupOpen] = useState(true);
  const navigate = useNavigate();
  const notifySuccess = (message) => toast.success(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
    // transition: Flip,
    });
  const notifyFailure = (message) => toast.error(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
    // transition: Flip,
    });

  const [formData, setFormData] = useState({
    bookedBy: "",
    email: "",
    number: "",
    date: "",
    age: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const isFormValid = () => {
      return (
        formData.bookedBy &&
        formData.email &&
        formData.number &&
        formData.age &&
        formData.date
      );
  };
  const saveBooking = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND}/api/booking-class`, formData);
      console.log(formData);
    } catch (error) {
      console.log(error);
    }
  }
  const appendDataToGoogleSheet = async () => {
    console.log('in function');
    try {
      
      const data = {
        values: 
          [formData.bookedBy, formData.email, formData.number, formData.age, formData.date],
        class: true,
      };

      console.log(data);
  
      // Send a POST request to the backend route
      await axios.post(`${process.env.REACT_APP_BACKEND}/api/util/append_sheet`, data);
  
      console.log("Data appended to Google Sheet successfully!");
    } catch (error) {
      console.error("Error appending data to Google Sheet:", error);
    }
  };

  const sendMail = async () => {
    axios.post(`${process.env.REACT_APP_BACKEND}/api/util/confirm-class`, { email: formData.email, name: formData.bookedBy, date: formData.date, number: formData.number});
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const bookingData = {
      ...formData
    };


    try {
      // await axios.post(`http://${process.env.REACT_APP_BACKEND}/api/booking-class`, bookingData);
      appendDataToGoogleSheet();
      sendMail();
      saveBooking();
      notifySuccess('Booking Successful')

      setIsPopupOpen(false);
    } catch (error) {

      notifyFailure('Booking Failed')
    } finally {
      navigate(-1);
    }
  };

  const handleClose = () => {
    setIsPopupOpen(false);
    navigate(-1);
  };

  const handleOutsideClick = () => {};

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === "Escape") {
        setIsPopupOpen(false);
        navigate(-1);
      }
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, []);

  if (!isPopupOpen) return null;

  const toggleTheme = () => {
    const nextTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(nextTheme);
    localStorage.setItem('bookingTheme', nextTheme);
  };

  // Calculate today's date in YYYY-MM-DD format
  const today = new Date().toISOString().split("T")[0];

  return (
    <div className="popup-overlay" onClick={handleOutsideClick}>
      <div className="popup-content" data-theme={theme}>
        <div className="popup-header">
          <h1 className="form-title">Book a Sailing Class</h1>
          <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
            {theme === 'dark' ? 'Light' : 'Dark'}
          </button>
          <button className="close-button" onClick={handleClose} aria-label="Close booking form">
            &times;
          </button>
        </div>
        <form onSubmit={handleSubmit} className="booking-form">
          <h2>Personal Information</h2>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="bookedBy">Name: <span className="required">*</span></label>
              <input
                id="bookedBy"
                type="text"
                name="bookedBy"
                value={formData.bookedBy}
                onChange={handleChange}
                required
                placeholder="Enter your full name"
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email: <span className="required">*</span></label>
              <input
                id="email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="example@email.com"
              />
              <small className="field-hint">Confirmation will be sent to this email</small>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="number">Phone Number: <span className="required">*</span></label>
              <PhoneInput
                id="number"
                value={formData.number}
                onChange={(val) => setFormData((prev) => ({ ...prev, number: val }))}
                required
                placeholder="Phone number"
              />
            </div>
            <div className="form-group">
              <label htmlFor="age">Age: <span className="required">*</span></label>
              <input
                id="age"
                type="number"
                name="age"
                value={formData.age}
                onChange={handleChange}
                required
                placeholder="Enter your age"
              />
            </div>
          </div>

          <h2>Class Details</h2>
          <div className="form-group">
            <label htmlFor="date">Preferred Date: <span className="required">*</span></label>
            <input
              id="date"
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
              min={today}
            />
            <small className="field-hint">Select a date for your class (must be today or later)</small>
          </div>

          {isFormValid() && (
            <button type="submit" className="submit-button">
              Submit Booking
            </button>
          )}
          {!isFormValid() && (
            <small className="submit-hint">All required fields must be completed before proceeding</small>
          )}
        </form>
      </div>
    </div>
  );
}

export default BookingForm;
